/**начальная часть урла расположения нашего АПИ */
const _urlPrefix = "https://chz.vetwizard.ru:8090/api/v1/chzkm/";

/**Предназначена для построения заголовка запроса */
const _buildHeader = (request) => ({
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
        'Content-Type': 'text/plain' //'application/json;charset=utf-8' // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *client
    body: JSON.stringify(request),
})

/**для построения меты для большинства запросов */
const _getMeta = () => {
    const storedToken = localStorage.getItem('token')
    if(storedToken) return {token:storedToken};
    return undefined
}

/**отпправляет запрос request по адресу оканчивающимуся на url. Начальная часть адреса
 * берется из локальной переменной _urlPrefix
  */
const _sendRequest = async (request, url) => {
    try {
        const resp = await fetch(_urlPrefix + url, _buildHeader(request));
        if (!resp.ok) {
            throw new Error(`Response status: ${resp.status}`);
        }

        const json = await resp.json();
        return json;
    } catch (error) {
        throw (error)
    }
}

/**логин пользователя */
const login = async (userId) => {
    
    return await _sendRequest({meta:_getMeta(), payload:{userId}}, 'login')
}

/**логаут пользователя */
const logout = async (token) => {
    return await _sendRequest({meta:_getMeta(), payload:{token}}, 'logout')
}

/**запрос данных по отсканированному коду */
const checkCode = async (payload) => {
    return await _sendRequest({meta:_getMeta(), payload}, 'checkkm')
}

/**запрос данных по отсканированному агрегационному коду */
const checkAggr = async (payload) => {
    return await _sendRequest({meta:_getMeta(), payload}, 'checkaggr')
}

/**запрос данных по отсканированному агрегационному коду */
const closeAggr = async (payload) => {
    return await _sendRequest({meta:_getMeta(), payload}, 'closeaggr')
}


/**сохранение данных карты */
const sendCard = async (card) => {
    return await _sendRequest({meta:_getMeta(), payload:card}, 'savecard')
}

/**получение настроек */
const getSettings = async () => {
    return await _sendRequest({meta:_getMeta()}, 'getsettings')
}

/**поиск товара */
const findProduct = async (find) => {
    return await _sendRequest({meta:_getMeta(), payload:find}, 'find')
}

/**получение списка доступных для работы заказов */
const getOrderList = async () =>{
  return await  _sendRequest({meta:_getMeta()}, 'getorderlist')
}

/**проверка доступности кода агрегации для замены */
const checkReplaceAggr = async (payload) =>{
  return await  _sendRequest({meta:_getMeta(), payload}, 'checkreplaceaggr')
}

/**замена кода агрегации на другой */
const replaceAggr = async (payload) =>{
  return await  _sendRequest({meta:_getMeta(), payload}, 'replaceaggr')
}

/**замена кода агрегации на другой */
const checkBar = async (payload) =>{
  return await  _sendRequest({meta:_getMeta(), payload}, 'getproductlevelsbycode')
}

/**Запрос основного отчета */
const getGenReport = async (payload) =>{
  return await  _sendRequest({meta:_getMeta(), payload}, 'getgenreport')
}

/**Запрос отчета по пользователям */
const getUserReport = async (payload) =>{
  return await  _sendRequest({meta:_getMeta(), payload}, 'getuserreport')
}



export {
  login, 
  logout, 
  checkCode, 
  sendCard, 
  getSettings, 
  findProduct, 
  checkAggr, 
  closeAggr, 
  getOrderList, 
  checkReplaceAggr,
  replaceAggr, 
  checkBar,
  getGenReport,
  getUserReport,
}